import i18n from 'src/i18n';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'first_name',
            label: i18n.t('common_words.name'),
            minWidth: 150,
            sortable: true,
            formatter: (row) => {
                return `${row.first_name} ${row.last_name}`;
            },
        },
        {
            prop: 'nit',
            label: i18n.t('common_words.nit'),
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'bank_account',
            label: i18n.t('inventory.bank_account'),
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'account_type',
            label: i18n.t('inventory.account_type'),
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'bank_name',
            label: i18n.t('inventory.bank_name'),
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'first_name',
            label: `${i18n.t('common_words.contacts')}`,
            show: false,
            providerContact: true,
        },
    ];

    return { tableColumns };
};

export default configTable;
